<app-slider></app-slider>
<!-- <app-booking-component></app-booking-component> -->

<app-home-about></app-home-about>
<!-- <app-rooms></app-rooms> -->
<app-notch></app-notch>

<!-- <app-toasts aria-live="polite" aria-atomic="true"></app-toasts> -->

 <div class="container">
        <h1>Our Hotel Location</h1>
        <div class="hotel-cards">
            <div class="hotel-card">
                <img src="assets\images\greenstarinnpremium.jpg" alt="The Greenstar Inn">
                <div class="card-content">
                    <div class="rating">
                        <span>⭐</span> <span>4.3</span>
                    </div>
                    <h2>The Greenstar Inn</h2>
                    <p>Near Biju pattanaik airport, Bhubaneswar</p>
                    <button class="tag">Couple Friendly</button>
                </div>
                <button class="details-btn">View Details</button>
            </div>
            <div class="hotel-card">
                <img src="assets\images\greenstarinn.jpg" alt="The Greenstar Inn Premium">
                <div class="card-content">
                    <div class="rating">
                        <span>⭐</span> <span>4.8</span>
                    </div>
                    <h2>The Greenstar Inn Premium</h2>
                    <p>Near Sum Hospital, Bhubaneswar</p>
                    <button class="tag">Couple Friendly</button>
                </div>
                <button class="details-btn">View Details</button>
            </div>
        </div>
    </div>

      <div class="amenities-section">
        <h2>Rooms and Amenities</h2>
        <div class="amenities-grid">
            <div class="amenity">
                <i class="fa fa-home" aria-hidden="true"></i>
                <span>In-House Restaurant</span>
            </div>
            <div class="amenity">
                <i class="fa fa-wifi" aria-hidden="true"></i>
                <span>Free and Fast</span>
            </div>
            <div class="amenity">
                <i class="fa fa-television" aria-hidden="true"></i>
                <span>Satellite and Cable Tv</span>
            </div>
            <div class="amenity">
                <i class="fa fa-window-maximize" aria-hidden="true"></i>
                <span>AC</span>
            </div>
            <div class="amenity">
                <i class="fa fa-coffee" aria-hidden="true"></i>
                <span>Coffee Machine</span>
            </div>
            <div class="amenity">
                <i class="fa fa-car" aria-hidden="true"></i>
                <span>Car Parking</span>
            </div>
            <div class="amenity">
                <i class="fa fa-credit-card-alt" aria-hidden="true"></i>
                <span>Card Payment</span>
            </div>
            <div class="amenity">
                <i class="fa fa-cutlery" aria-hidden="true"></i>
                <span>Kitchen</span>
            </div>
            <div class="amenity">
                <i class="fa fa-bath" aria-hidden="true"></i>
                <span>Geyser</span>
            </div>
            <div class="amenity">
                <i class="fa fa-battery-full" aria-hidden="true"></i>
                <span>Power Backup</span>
            </div>
            <div class="amenity">
                <i class="fa fa-camera" aria-hidden="true"></i>
                <span>CCTV Cameras</span>
            </div>
            <div class="amenity">
                <i class="fa fa-fire-extinguisher" aria-hidden="true"></i>
                <span>Fire-Extinguisher</span>
            </div>
        </div>
    </div>

<!-- <div id="attractions" class="nearby-places-section">
  <h2 style="color: #000;" class="features-heading">NEARBY PLACES<br>
    <span class="sub-head-span" style="color: #379237">The Greenstar Inn (Near Biju Pattanaik Airport)</span></h2>
  <h2 class="section-heading">Greenstar Inn Nearby Places <br>(Near Biju Pattanaik Airport , Bhubaneswar)</h2>
  <div class="unique-cards-container">
    <div class="card unique-card">
      <img src="assets/images/Railway Station.jpg" class="card-img-top" alt="Railway station">
      <div class="card-body">
        <p class="card-text">Railway Station</p>
        <span class="text-muted">Distance From Hotel to Railway station <strong> 3.4 km (10 min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Airport.jpg" class="card-img-top" alt="Airport">
      <div class="card-body">
        <p class="card-text">biju pattnaik  airport </p>
        <span class="text-muted">Distance From Hotel to airport <strong> 1.4 km (4 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Busstop.jpg" class="card-img-top" alt="Bus Stop">
      <div class="card-body">
        <p class="card-text">Babasaheb Bhim Rao Ambedkar Bus Terminal </p>
        <span class="text-muted">Distance From Hotel to Babasaheb Bhim Rao Ambedkar Bus Terminal <strong> 4.8 km (12
            min)</strong> </span>

      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Esplanade.jpg" class="card-img-top" alt="Esplanade Mall">
      <div class="card-body">
        <p class="card-text">Esplanade Mall</p>
        <span class="text-muted">Distance From Hotel to Esplanade Mall <strong> 7.1 km (17 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Symphony Mall.jpg" class="card-img-top" alt="Symphony Mall">
      <div class="card-body">
        <p class="card-text">Symphony Mall</p>
        <span class="text-muted">Distance From Hotel to Symphony Mall <strong> 12 km (23 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Rammandir.jpg" class="card-img-top" alt="Shri Ram Temple">
      <div class="card-body">
        <p class="card-text">Shri Ram Temple</p>
        <span class="text-muted">Distance From Hotel to Shri Ram Temple <strong> 4.3 km (10 min)</strong> </span>

      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Dhauli.webp" class="card-img-top" alt="Dhauligiri">
      <div class="card-body">
        <p class="card-text">Dhauli Shanti Stupa</p>
        <span class="text-muted">Distance From Hotel to Dhauli Shanti stupa <strong> 12 km (24 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Khandagiri.jpg" class="card-img-top" alt="Khandagiri and Udayagiri Caves">
      <div class="card-body">
        <p class="card-text">Khandagiri and Udayagiri Hills</p>
        <span class="text-muted">Distance From Hotel to Khandagiri and Udayagiri Hills <strong> 5.8km (13
            min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Nadankanan.jpg" class="card-img-top" alt="Nadankanan">
      <div class="card-body">
        <p class="card-text">Nadankanan Zoological Park</p>
        <span class="text-muted">Distance From Hotel to Nadankanan Zoological Park <strong> 17 km (32 min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Botanical Garden.jpg" class="card-img-top" alt="State Botanical Garden">
      <div class="card-body">
        <p class="card-text">State Botanical Garden</p>
        <span class="text-muted">Distance From Hotel to State Botanical Garden <strong> 19 km (37 min)</strong></span>
      </div>
    </div>
  </div>
</div> -->

<!-- <div id="attractions" class="nearby-places-section">
  <h2 style="color: #000;" class="features-heading">NEARBY PLACES<br>
    <span class="sub-head-span" style="color: #379237">The Greenstar Premium (Near Sum Hospital)</span></h2>
   <h2 class="section-heading">Greenstar Inn Premium Nearby Places <br>(Near Sum Hospital , Bhubaneswar)</h2>
  <div class="unique-cards-container">
    <div class="card unique-card">
      <img src="assets/images/Railway Station.jpg" class="card-img-top" alt="Railway station">
      <div class="card-body">
        <p class="card-text">Railway Station</p>
        <span class="text-muted">Distance From Hotel to Railway station <strong> 10.1 km (23 min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Airport.jpg" class="card-img-top" alt="Airport">
      <div class="card-body">
        <p class="card-text">biju pattnaik  airport </p>
        <span class="text-muted">Distance From Hotel to airport <strong> 7.5 km (18 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Busstop.jpg" class="card-img-top" alt="Bus Stop">
      <div class="card-body">
        <p class="card-text">Babasaheb Bhim Rao Ambedkar Bus Terminal </p>
        <span class="text-muted">Distance From Hotel to Babasaheb Bhim Rao Ambedkar Bus Terminal <strong> 4.8 km (12
            min)</strong> </span>

      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Esplanade.jpg" class="card-img-top" alt="Esplanade Mall">
      <div class="card-body">
        <p class="card-text">Esplanade Mall</p>
        <span class="text-muted">Distance From Hotel to Esplanade Mall <strong> 11.1 km (25 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Symphony Mall.jpg" class="card-img-top" alt="Symphony Mall">
      <div class="card-body">
        <p class="card-text">Symphony Mall</p>
        <span class="text-muted">Distance From Hotel to Symphony Mall <strong> 13.9 km (35 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Rammandir.jpg" class="card-img-top" alt="Shri Ram Temple">
      <div class="card-body">
        <p class="card-text">Shri Ram Temple</p>
        <span class="text-muted">Distance From Hotel to Shri Ram Temple <strong> 9.2 km (20 min)</strong> </span>

      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Dhauli.webp" class="card-img-top" alt="Dhauligiri">
      <div class="card-body">
        <p class="card-text">Dhauli Shanti Stupa</p>
        <span class="text-muted">Distance From Hotel to Dhauli Shanti stupa <strong> 19.5km (40 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Khandagiri.jpg" class="card-img-top" alt="Khandagiri and Udayagiri Caves">
      <div class="card-body">
        <p class="card-text">Khandagiri and Udayagiri Hills</p>
        <span class="text-muted">Distance From Hotel to Khandagiri and Udayagiri Hills <strong> 6.4km (14
            min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Nadankanan.jpg" class="card-img-top" alt="Nadankanan">
      <div class="card-body">
        <p class="card-text">Nadankanan Zoological Park</p>
        <span class="text-muted">Distance From Hotel to Nadankanan Zoological Park <strong> 20.6km (45
            min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Botanical Garden.jpg" class="card-img-top" alt="State Botanical Garden">
      <div class="card-body">
        <p class="card-text">State Botanical Garden</p>
        <span class="text-muted">Distance From Hotel to State Botanical Garden <strong> 17.5 km (30 min)</strong></span>
      </div>
    </div>
  </div>
</div> -->


<!-- <div class="gallery-container">
  <div class="gallery-images-section">
    <h2 style="color: #000;" class="features-heading">VISIT GALLERY<br>
      <span class="sub-head-span" style="color: #379237">The Greenstar Premium (Near Sum Hospital)</span></h2>

    <ngx-slick-carousel class="gallery-carousel" *ngIf="isMobileView" [config]="slideConfig">
      <div ngxSlickItem *ngFor="let image of property?.imageList" class="gallery-image-card">
        <img [src]="image.url" alt="Property Image">
      </div>
    </ngx-slick-carousel>

    <div class="gallery-image-grid">
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img24.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/greenstarinnpremium.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/grnstar-premium1.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/grnstar-premium2.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/grnstar-premium3.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/grnstar-premium4.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/grnstar-premium7.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/grnstar-premium8.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img38.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img26.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img10.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img20.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img17.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img19.jpeg">
      </div>
    </div>
  </div>
</div> -->

<!-- <div class="gallery-container">
  <div class="gallery-images-section">
    <h2 style="color: #000;" class="features-heading">VISIT GALLERY<br>
      <span class="sub-head-span" style="color: #379237">The Greenstar (Near Biju Pattanaik Airport)</span></h2>
    <ngx-slick-carousel class="gallery-carousel" *ngIf="isMobileView" [config]="slideConfig">
      <div ngxSlickItem *ngFor="let image of property?.imageList" class="gallery-image-card">
        <img [src]="image.url" alt="Property Image">
      </div>
    </ngx-slick-carousel>

    <div class="gallery-image-grid">
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img45.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/greenstarinn.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img35.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img33.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img2.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img31.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img43.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img37.jpeg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/img44.jpg">
      </div>
  </div>
</div> -->

<!-- reviews section -->
<!-- <div class="testimonial-container">
  <div class="container my-5 tst-div">
    <h1 class="headline font-weight-bold"
      style="text-align: center; margin-bottom: 20px;font-size: 26px; margin-bottom: 20px;color: #000;text-transform: uppercase;letter-spacing: 1px;">
      Testimonials</h1>
    <div class="row" id="testimonials">
      <div class="col-md-4 mb-4 d-flex flex-column justify-content-center align-items-start">
        <h2 class="headline font-weight-bold mb-3" style="text-align: center !important;">The Greenstar Inn (Near Biju Pattanaik Airport, Bhubaneswar)</h2>
        <p class="intro-text mb-4 text-muted">Here's what our guests are saying...</p>
        <a href="https://search.google.com/local/writereview?placeid=ChIJxXu6peanGToRDwwXqIs4YAo"
          class="btn btn-primary btn-lg writereview">
          <div style="padding-left: 10px;padding-right: 10px; color: white;">
            Write a Review
          </div>
        </a>
      </div>
      <div class="col-md-8 mb-4 d-md-block">
        <div class="card shadow-sm border-0 h-100">
          <div id="carouselGreenstarInn" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner c-review-carousel" style="display: block;">
              <div class="carousel-item" data-interval="10000" *ngFor="let item of googleReviews; let i = index"
                [ngClass]="{ 'active': i === 0 }">
                <div class="row">
                  <div class="col-md-12 d-flex justify-content-center">
                    <div class="c-review p-3">
                      <div style="text-align: center;">
                        <div>
                          <img src="assets/images/user.png" alt="{{ item.reviewerName }}"
                            class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" />
                        </div>
                        <div>
                          <h5 class="font-weight-bold mb-1">{{ item.reviewerName }}</h5>
                        </div>
                        <div>
                          <p class="small text-muted mb-2 c-review-text">{{ item.reviewText }}</p>
                        </div>
                        <div class="star-ratings text-warning">
                          {{ '★'.repeat(item.rating) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-controls">
            <a class="carousel-control-prev" href="#carouselGreenstarInn" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselGreenstarInn" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="row" id="testimonials">
      <div class="col-md-4 mb-4 d-flex flex-column justify-content-center align-items-start">
        <h2 class="headline font-weight-bold mb-3" style="text-align: center !important;">The Greenstar Inn Premium (Near Sum Hospital, Bhubaneswar)</h2>
        <p class="intro-text mb-4 text-muted">Here's what our guests are saying...</p>
        <a href="https://search.google.com/local/writereview?placeid=ChIJD1S0XQAIGToR_LESzokscRc"
          class="btn btn-primary btn-lg writereview">
          <div style="padding-left: 10px;padding-right: 10px; color: white;">
            Write a Review
          </div>
        </a>
      </div>
      <div class="col-md-8 mb-4 d-md-block">
        <div class="card shadow-sm border-0 h-100">
          <div id="carouselGreenstarPremium" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner c-review-carousel" style="display: block;">
              <div class="carousel-item" data-interval="10000" *ngFor="let item of googleReviewsOptional; let i = index"
                [ngClass]="{ 'active': i === 0 }">
                <div class="row">
                  <div class="col-md-12 d-flex justify-content-center">
                    <div class="c-review p-3">
                      <div style="text-align: center;">
                        <div>
                          <img src="assets/images/user.png" alt="{{ item.reviewerName }}"
                            class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" />
                        </div>
                        <div>
                          <h5 class="font-weight-bold mb-1">{{ item.reviewerName }}</h5>
                        </div>
                        <div>
                          <p class="small text-muted mb-2 c-review-text">{{ item.reviewText }}</p>
                        </div>
                        <div class="star-ratings text-warning">
                          {{ '★'.repeat(item.rating) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-controls">
            <a class="carousel-control-prev" href="#carouselGreenstarPremium" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselGreenstarPremium" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
<!-- <div class="gallery-container location" id="location">
  <h1 class="headline font-weight-bold"
    style="margin-bottom: 20px; text-align: center; margin-bottom: 20px;font-size: 28px;font-weight: 700;margin-bottom: 20px;color: #333333;text-transform: uppercase;letter-spacing: 1px;">
    Locations</h1>
  <div
    style="margin-bottom: 2px; display: flex; flex-wrap: wrap; justify-content: space-between; gap: 20px;">
    <div style="flex: 1; min-width: 300px; max-width: 48%; height: 600px; position: relative;" class="loc">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d120400.97754900219!2d85.73771431247633!3d20.257359452917008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3a19a7e6a5ba7bc5%3A0xa60388ba8170c0f!2s223%2F2751%2C%20near%20Bijupatnaik%20international%20Airport%2C%20Forest%20Park%2C%20Bhubaneswar%2C%20Odisha%20751020!3m2!1d20.2573968!2d85.82008859999999!5e1!3m2!1sen!2sin!4v1745404605277!5m2!1sen!2sin"
        width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>

      <div class="card map-card" style="position: absolute; top: 50px; text-align: center; left: 50px; background-color: white; border-bottom-left-radius: 61px;box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top-right-radius: 59px;
    padding: 50px; width: 80%;">
        <h3>The Greenstar Inn (Near Biju Pattnaik Airport, Bhubaneswar)</h3>
        <p>We're here to assist you with any questions, requests, or bookings.<br> Please don't hesitate to reach out to
          us.</p>
        <button class="book-btn" (click)="navigate()">Book Your Stay</button>
        <p class="contact-footer">
          <i class="fa fa-phone"></i>8249093974
        </p>
        <p class="contact-footer">
          <i class="fa fa-envelope"></i>thegreenstarinnreservation@gmail.com
        </p>
      </div>
    </div>
    <div style="flex: 1; min-width: 300px; max-width: 48%; height: 600px; position: relative;" class="loc">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d120378.19179677487!2d85.69185061330124!3d20.286719129844172!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3a1908005db4540f%3A0x17712c89ce12b1fc!2sPlot%20No-789%2F1328%2C%20near%20Sum%20Hospital%20Road%2C%20Durga%20Madhab%20Nagar%2C%20Shampur%2C%20Bhubaneswar%2C%20Odisha%20751003!3m2!1d20.2867384!2d85.7742523!5e1!3m2!1sen!2sin!4v1745405892828!5m2!1sen!2sin"
        width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>
      <div class="card map-card" style="position: absolute; top: 50px; text-align: center; left: 50px; background-color: white; border-bottom-left-radius: 61px;box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top-right-radius: 59px;
    padding: 50px; width: 80%;">
        <h3>The Greenstar Inn Premium (Near Sum Hospital , Bhubaneswar)</h3>
        <p>We're here to assist you with any questions, requests, or bookings.<br> Please don't hesitate to reach out to
          us.</p>
        <button class="book-btn" (click)="navigate()">Book Your Stay</button>
        <p class="contact-footer">
          <i class="fa fa-phone"></i>8249093974
        </p>
        <p class="contact-footer">
          <i class="fa fa-envelope"></i>thegreenstarinnreservation@gmail.com
        </p>
      </div>
    </div>
  </div>
</div> -->
<!-- Dialogflow Messenger Integration -->
<df-messenger project-id="impactful-name-306810" agent-id="8bb6c52c-8667-4a24-a789-4cd78b154c96" intent="WEBSITE"
  storage-option="none" language-code="en" max-query-length="-1">
  <df-messenger-chat-bubble id="chatbot" chat-subtitle=""></df-messenger-chat-bubble>
</df-messenger>
<a [href]="getWhatsappShareUrl()" class="float" target="_blank">
  <i class="fa fa-whatsapp my-float"></i>
</a>

<!-- <app-near-places></app-near-places> -->


